/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2021-12-07 14:24:53
 * @LastEditors: zhanghang
 * @LastEditTime: 2021-12-10 18:02:29
 */
export default function (dsf, options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    asqType:"orders",
    group:"",
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    dataSourceWatch: true,
    defaultValue: null,
    dataSource: {
      code: null,
      type: "static",
      attach: [],
    },
    valueAttributes: [{
      name: "值",
      code: "value",
      type: dsf.metadata.getDataType("string"),
      length: 100,
      defaultValue: null,
      emptyValidate: true,
      encrypt: false,
      unit: null
    },
    {
      name: "文本",
      code: "text",
      type: dsf.metadata.getDataType("string"),
      length: 100,
      defaultValue: null,
      encrypt: false,
      unit: null
    }, {
      name: "排序",
      code: "ds_order",
      type: dsf.metadata.getDataType("string"),
      length: 100,
      defaultValue: null,
      encrypt: false,
      unit: null
    }]
  };
}